// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"279":"04793f3d","344":"dabf5f67","428":"522a6691","932":"e51e4d83","965":"38402728"}[chunkId] + ".chunk.js";
};